import "flatpickr/dist/themes/material_blue.css";
import "../../assets/scss/datatables.scss";

import * as confirmAction from "../../store/confirm/action";
import * as loadingAction from "../../store/loading/action";
import * as messageAction from "../../store/message/action";

import {
  AUTO_CAL,
  AUTO_EX_CAL,
  CHANGE_DATA_ON_SELECT,
  CREATE_NEW_REVISION,
  GET_ALL_SELECT,
  GET_DT_SOURCE_WITH_COM,
  GET_FLOW_DATA,
  GET_FLOW_DATA_MAX_MIN_10DAY,
  GET_QTY_POINT_DATA,
  SAVE_LIST_FLOW_DATA,
} from "../../helpers/url_api_constant";
import { AvField, AvForm } from "availity-reactstrap-validation";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import { Link, useHistory, useParams } from "react-router-dom";
import MessageDialog, {
  useModalShowMessage,
} from "../../components/Custom/MessageDialog";
import PropTypes, { number, objectOf } from "prop-types";
import React, { useEffect, useState } from "react";
import Select, {
  MultiValueGenericProps,
  MultiValueRemoveProps,
  OptionProps,
  components,
} from "react-select";
import { connect, useDispatch } from "react-redux";

import BootstrapTable from "react-bootstrap-table-next";
import Flatpickr from "react-flatpickr";
import Loading from "../../components/Custom/Loading";
import OverButton from "../../components/Custom/Overbutton";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import VirtualMeterDetail from "./VirtualMeterDetail";
import cellEditFactory from "react-bootstrap-table2-editor";
import chroma from "chroma-js";
import { getPermission } from "../../helpers/auth_helper";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
import { post } from "../../helpers/api_helper";
import { set } from "lodash-es";
import { withTranslation } from "react-i18next";

let itemChanged = [];
let originalModelList = [];
function numberFormat(number, digit = 2) {
  if (number === null || number === "null" || number === "") return "";
  function isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
  }
  if (isFloat(number))
    return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  return parseFloat(number).toLocaleString(undefined, {
    minimumFractionDigits: digit,
  });
}
function FlowSelection(props) {
  const dispatch = useDispatch();
  let history = useHistory();
  let { mode, pid } = useParams();
  const permission = getPermission();
  // console.log(mode);
  const searchObj = {
    METER_NAME: "",
    METER_TYPE: "",
    COMTYPE_NAME: "",
    AREA_NAME: "",
    ZONE_NAME: "",
    SELECT_DATE: moment().add("days", -1).format("YYYY-MM-DD"),
  }; // METER_NAME:"", METER_TYPE:""
  const createObj = {
    LOAD_REV: "",
    LOAD_DESC: "",
    LOAD_STATUS: "",
    REFRESH_DATE_TIME: moment(new Date()).format("YYYY-MM-DD, HH:mm:ss"),
  };
  const pidToSearchConf = { PID: pid };
  const [tempSearch, setTempSearch] = useState({
    SELECT_DATE: moment().add("days", -1).toDate(),
  });
  const colorOption = [
    { label: "#109600", value: 1 },
    { label: "#FCF400", value: 2 },
    { label: "#FF0101", value: 3 },
  ];
  const [dataFlowConf, setDataFlowConf] = useState({});
  const [createModel, setCreateModel] = useState(createObj);
  const [searchModel, setSearchModel] = useState(searchObj);
  const [filterModel, setFilterModel] = useState({
    COMTYPE_NAME: "",
    METER_TYPE: "",
    METER_NAME: "",
    AREA_NAME: "",
    ZONE_NAME: "",
    FLOWVOLUME_STATUS: [...colorOption],
    ENERGY_STATUS: [...colorOption],
    BLANK_FIELD: false,
    // FLOWVOLUME_STATUS: {
    //   green: true,
    //   yellow: true,
    //   red: true,
    // },
    // ENERGY_STATUS: {
    //   green: true,
    //   yellow: true,
    //   red: true,
    // },
  });
  const [isLoading, setIsLoading] = useState(false);
  const [readonly, setReadonly] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [modalRevision, setModalRevision] = useState(false);
  const [modalRefreshAll, setModalRefreshAll] = useState(false);
  const [virtualMeter, setVirtualMeter] = useState({});
  const [modalChangeInput, setModalChangeInput] = useState(false);
  const [filterTempModel, setFilterTempModel] = useState({
    COMTYPE_NAME: "",
    METER_TYPE: "",
    METER_NAME: "",
    AREA_NAME: "",
    ZONE_NAME: "",
    FLOWVOLUME_STATUS: [...colorOption],
    ENERGY_STATUS: [...colorOption],
    BLANK_FIELD: false,
  });

  const [dropDownSearchCommunicationType, setDropDownSearchCommunicationType] =
    useState(null);
  const [dropDownSearchZone, setDropDownSearchZone] = useState(null);
  const [dropDownSearchArea, setDropDownSearchArea] = useState(null);
  const [dropDownSearchCustomerType, setDropDownSearchCustomerType] =
    useState(null);
  const [listCommunicationType, setListCommunicationType] = useState([]);
  const [listZone, setListZone] = useState([]);
  const [listArea, setListArea] = useState([]);
  const [listCustomerType, setListCustomerType] = useState([]);

  // const [filterFlowVolumeStatus, setFilterFlowVolumeStatus] = useState({
  //   green: true,
  //   yellow: true,
  //   red: true,
  // });
  // const [filterEnergyStatus, setFilterEnergyStatus] = useState({
  //   green: true,
  //   yellow: true,
  //   red: true,
  // });
  const {
    showMessage,
    toggleModalMessage,
    bodyMessageModal,
    titleMessageModal,
  } = useModalShowMessage();

  const [flagAllVolAndEng, setFlagAllVolAndEng] = useState({
    allVolume: false,
    allEnergy: false,
  });

  // DropDown
  const [dropDownInput, setDropDownInput] = useState(null);
  const [dropDownStatus, setDropDownStatus] = useState(null);
  // DropDown
  const selectColorOption = {
    control: styles => ({ ...styles, backgroundColor: "white" }),
    input: styles => ({ ...styles, ...dot() }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      const color = chroma(data.label);
      return {
        ...styles,
        backgroundColor: isDisabled
          ? undefined
          : isSelected
          ? data.color
          : isFocused
          ? color.alpha(0.1).css()
          : undefined,
        color: data.label,
        cursor: isDisabled ? "not-allowed" : "default",

        ":active": {
          ...styles[":active"],
          backgroundColor: !isDisabled
            ? isSelected
              ? data.color
              : color.alpha(0.3).css()
            : undefined,
        },
      };
    },

    singleValue: (styles, { data }) => ({ ...styles, ...dot(data.label) }),
    multiValue: (styles, { data }) => {
      const color = chroma(data.label);
      return {
        ...styles,
        // color:data.label,
        backgroundColor: "#2E3446",

        // ...dot(data.label)
      };
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: data.label,
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      position: "absolute",
      top: "50%",
      letf: "50%",
      padding: 0,
      transform: `translate(35%, -50%)`,
      color: data.label,
      ":hover": {
        // backgroundColor: data.label,
        color: "white",
      },
    }),
  };
  // Handle Set Value DropDown //
  const handleSelectDropDownInput = selected => {
    setDropDownInput(selected);
  };

  const handleSelectDropDownStatus = selected => {
    setDropDownStatus(selected);
  };

  const handleSelectDropDownQualityPoint = (selected, row) => {
    setModelDeviceList(prevData => {
      return prevData.map(item => {
        if (item.PID === row.PID) {
          // console.log(item);
          return {
            ...item,
            QTYPOINT_NAME: selected.name,
            QTYPOINT_PID: selected.pid,
            QTYPOINT_SOURCE: selected.source,
            HEATVALUE: selected.value == "" ? 0 : selected?.value?.toFixed(2),
            OptionSelected: { ...item.OptionSelected, QTYPOINT_NAME: selected },
          };
        }
        return { ...item };
      });
    });
    enegyCalculate();
    if (row.FLOWSOURCE_NAME == "Nomination") {
      let data = {
        METER_NAME: row.METER_NAME,
        NOMINATE_NAME: row.NOMINATE_NAME,
        SOURCE_NAME: selected.label,
        LOAD_DATE: moment(row.SELECT_DATE).format("YYYY-MM-DD"),
      };
      volumeCalculate(data);
    }
  };

  const handleSelectDropDownVolumeInput = (selected, row) => {
    let flag = 1;

    setModelDeviceList(prevData => {
      return prevData.map(item => {
        if (item.PID === row.PID) {
          let status = {};
          if (selected.label == item.FLOWSOURCEREF_NAME)
            status = { FLOWVOLUME_STATUS: item.FLOWVOLUMEREF_STATUS };
          return {
            ...item,
            ...status,
            // ...(selected.label!=item.FLOWSOURCEREF_NAME&&item.FLOWVOLUME_STATUS==item.FLOWVOLUMEREF_STATUS&&{FLOWVOLUME_STATUS:item.FLOWVOLUMEOLD_STATUS,FLOWVOLUMEOLD_STATUS:null}),
            FLOWSOURCE_NAME: selected.label,
            FLOWSOURCE_PID: selected.value,
            OptionSelected: {
              ...item.OptionSelected,
              FLOWSOURCE_NAME: selected,
            },
          };
        }
        return { ...item };
      });
    });
    let data = {
      METER_NAME: row.METER_NAME,
      NOMINATE_NAME: row.NOMINATE_NAME,
      SOURCE_NAME: selected.label,
      LOAD_DATE: moment(row.SELECT_DATE).format("YYYY-MM-DD"),
    };
    // if (selected.label != "Manual") {
    changeDataOnInput(data, row, flag);
    // }
  };

  const handleSelectDropDownEnergyInput = (selected, row) => {
    let flag = 3;
    setModelDeviceList(prevData => {
      return prevData.map(item => {
        if (item.PID === row.PID) {
          let status = {};
          if (selected.label == item.ENERGYSOURCEREF_NAME)
            status = { ENERGY_STATUS: item.ENERGYREF_STATUS };
          // if(selected.label!=item.ENERGYSOURCEREF_NAME&&item.ENERGYREF_STATUS!=item.ENERGYREF_STATUS)status={ENERGY_STATUS:item.ENERGYOLD_STATUS,ENERGYOLD_STATUS:null}
          return {
            ...item,
            ...status,
            ENERGYSOURCE_NAME: selected.label,
            ENERGYSOURCE_PID: selected.value,
            OptionSelected: {
              ...item.OptionSelected,
              ENERGYSOURCE_NAME: selected,
            },
          };
        }
        return { ...item };
      });
    });
    let data = {
      METER_NAME: row.METER_NAME,
      NOMINATE_NAME: row.NOMINATE_NAME,
      SOURCE_NAME: selected.label,
      LOAD_DATE: moment(row.SELECT_DATE).format("YYYY-MM-DD"),
    };
    // if (selected.label != "Manual") {
    changeDataOnInput(data, row, flag);
    // }
  };
  // Handle Set Value DropDown //

  const listQualityPoint = [
    { label: "BCS1", value: "BCS1" },
    { label: "BCS2", value: "BCS2" },
    { label: "BCS3", value: "BCS3" },
    { label: "BCS4", value: "BCS4" },
    { label: "BCS5", value: "BCS5" },
    { label: "BCS6", value: "BCS6" },
    { label: "BCS7", value: "BCS7" },
  ];

  const listEnergyInput = [
    { label: "TPA", value: "TPA" },
    { label: "NG-Billing", value: "NG-Billing" },
    { label: "GDMR", value: "GDMR" },
    { label: "SCADA", value: "SCADA" },
    { label: "Manual", value: "Manual" },
    { label: "Calculate", value: "Calculate" },
  ];

  const listVolumeInput = [
    { label: "TPA", value: "TPA" },
    { label: "Billing", value: "Billing" },
    // { label: "NG-Billing", value: "NG-Billing" },
    { label: "GDMR", value: "GDMR" },
    { label: "SCADA", value: "SCADA" },
    { label: "Nomination", value: "Nomination" },
    { label: "Manual", value: "Manual" },
  ];

  const listStatus = [
    { label: "Pending", value: "Pending" },
    { label: "Prepared", value: "Prepared" },
    { label: "Active", value: "Active" },
  ];

  //sort Column//
  const defaultSorted = [
    {
      dataField: "METER_NAME",
      order: "asc",
    },
  ];
  //sort Column//

  //Sort Page//
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total ms-2">
      Showing {from}
      to {to}
      of {size}
      Results
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "25",
        value: 25,
      },
      {
        text: "30",
        value: 30,
      },
      {
        text: "50",
        value: 50,
      },
    ],
  };
  //Sort Page//

  const backToPageList = () => {
    history.push({ pathname: "/flow-selection", state: { goback: true } });
  };

  // Action Button//
  const ActionInputButtonLink = (cellContent, row) => {
    let data;
    if (row.Id == "1") {
      data = "TPA";
    } else if (row.Id == "2") {
      data = "NG-Billing";
    } else if (row.Id == "3") {
      data = "GMDR";
    } else if (row.Id == "4") {
      data = "SCADA";
    } else if (row.Id == "5") {
      data = "Nomination";
    } else if (row.Id == "6") {
      data = "Manual";
    } else {
      data = "Calculate";
    }
    return (
      <div>
        <Button
          color="link"
          onClick={() => setModalChangeInput(true)}
          className="btnlinkintable-center btn-sm"
          style={{ color: "#FFF8DC" }}
        >
          {data}{" "}
        </Button>{" "}
      </div>
    );
  };

  const DropDrownVolumeInput = (cellContent, row) => {
    //  if(row.METER_NAME=="IND-A1"){
    //   console.log(row.SourceList,row);
    // }
    return (
      <div>
        <Select
          value={cellContent}
          onChange={selected => handleSelectDropDownVolumeInput(selected, row)}
          options={row.SourceList}
          classNamePrefix="select2-selection"
          styles={SelectStyle}
        />
      </div>
    );
  };

  const DropDrownEnergyInput = (cellContent, row) => {
    // if(row.METER_NAME=="IND-A1"){
    //   console.log(row.SourceList,row);
    // }
    return (
      <div>
        <Select
          value={cellContent}
          onChange={selected => handleSelectDropDownEnergyInput(selected, row)}
          options={[
            ...row.SourceList,
            { label: "Calculate", value: row.CalculatePid },
          ]}
          classNamePrefix="select2-selection"
          styles={SelectStyle}
        />
      </div>
    );
  };
  const QtyOption = (props: OptionProps) => {
    const { label, value } = props;
    return (
      <components.Option {...props}>
        {props.label}{" "}
        {value && (
          <span style={{ fontSize: "10px", color: "#a6b0cf" }}>
            ({numberFormat(props.value, 3)})
          </span>
        )}
      </components.Option>
    );
  };
  const SelectStyle = {
    option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
      ...provided,
      ...(isFocused && { backgroundColor: "#2E3460" }),
    }),
  };
  const qtyOptionStyle = {
    menu: (provided, state) => ({
      ...provided,
      width: 270,
    }),
  };

  const DropDrownQualityPoint = (cellContent, row) => {
    return (
      <div>
        <Select
          value={cellContent}
          onChange={selected => handleSelectDropDownQualityPoint(selected, row)}
          options={row.QtyDataList}
          components={{ Option: QtyOption }}
          classNamePrefix="select2-selection"
          styles={{ ...qtyOptionStyle, ...SelectStyle }}
        />
      </div>
    );
  };
  const dot = (color = "transparent") => ({
    alignItems: "center",
    display: "flex",

    ":before": {
      backgroundColor: color,
      borderRadius: 10,
      content: '" "',
      display: "block",
      marginRight: 8,
      height: 10,
      width: 10,
    },
  });

  const ColorOption = ({ children, ...props }: OptionProps) => {
    return (
      <components.Option {...props}>
        <div
          style={{
            backgroundColor: children,
            width: "12px",
            height: "12px",
            borderRadius: "6px",
          }}
        ></div>
      </components.Option>
    );
  };
  const MultiValueLabelColor = ({
    children,
    ...props
  }: MultiValueGenericProps) => {
    return (
      <components.MultiValueLabel {...props}>
        <div
          style={{
            backgroundColor: children,
            width: "12px",
            height: "12px",
            borderRadius: "6px",
          }}
        ></div>
      </components.MultiValueLabel>
    );
  };
  const MultiValueRemovePropsColor = ({
    children,
    ...props
  }: MultiValueRemoveProps) => {
    return (
      <components.MultiValueRemove {...props}>
        <div
        // style={{ position:'absolute',backgroundColor:children, width: "10px", height: "10px" ,borderRadius:"5px"}}
        ></div>
      </components.MultiValueRemove>
    );
  };
  const energyStatus = (cellContent, row) => {
    let color;
    if (row.ENERGY_STATUS == 1) {
      color = "#109600";
    } else if (row.ENERGY_STATUS == 2) {
      color = "#FCF400";
    } else {
      color = "#FF0101";
    }
    // console.log(row.ENERGYREF_FLAG_CHECK_BOX)
    return (
      <div className="form-check-danger">
        {/* <div className="form-check form-check-primary"> */}
        <label className="form-check-label" htmlFor={row.PID + "energy"}>
          <i
            className="mdi mdi-circle align-middle mb-2"
            style={{ color: color }}
          ></i>
        </label>
        {color == "#FF0101" && (
          <input
            type="checkbox"
            className="form-check-input p-0 mt-1 m-0 ms-2"
            checked={row.ENERGYREF_FLAG_CHECK_BOX}
            id={row.PID + "energy"}
            onChange={e => {
              setModelDeviceList(prevData => {
                return prevData.map(item => {
                  if (row.PID == item.PID) {
                    return {
                      ...item,
                      ENERGYREF_FLAG: 1,
                      ENERGYREF_FLAG_CHECK_BOX: !item.ENERGYREF_FLAG_CHECK_BOX,
                    };
                  }
                  return { ...item };
                });
              });
            }}
          />
        )}{" "}
        {/* </div> */}{" "}
      </div>
    );
  };

  const flowVolumeStatus = (cellContent, row) => {
    // console.log(row);
    let color;
    if (row.FLOWVOLUME_STATUS == 1) {
      color = "#109600";
    } else if (row.FLOWVOLUME_STATUS == 2) {
      color = "#FCF400";
    } else {
      color = "#FF0101";
    }
    return (
      <div className="form-check-danger">
        {" "}
        {/* <div className="form-check form-check-primary"> */}{" "}
        <label className="form-check-label" htmlFor={row.PID + "volume"}>
          <i
            className="mdi mdi-circle align-middle mb-2"
            style={{ color: color }}
          ></i>
        </label>
        {color == "#FF0101" && (
          <input
            // style={{ margin: '0px',padding:'0px' }}
            type="checkbox"
            className="form-check-input p-0 mt-1 m-0 ms-2"
            id={row.PID + "volume"}
            checked={row.FLOWVOLUMEREF_FLAG_CHECK_BOX}
            onChange={() => {
              setModelDeviceList(prevData => {
                return prevData.map(item => {
                  if (row.PID == item.PID) {
                    return {
                      ...item,
                      FLOWVOLUMEREF_FLAG: 1,
                      FLOWVOLUMEREF_FLAG_CHECK_BOX:
                        !item.FLOWVOLUMEREF_FLAG_CHECK_BOX,
                    };
                  }
                  return { ...item };
                });
              });
            }}
          />
        )}
        {/* </div> */}
      </div>
    );
  };

  const CheckHeatingValue = (cellContent, row) => {
    // console.log(cellContent)
    if (row.HEATVALUE == null) {
      cellContent = "";
    } else {
      cellContent = row.HEATVALUE;
    }
    return (
      <div className="justify-content-between">
        {row.QTYPOINT_SOURCE == "Manual" && (
          <i className="fas fa-edit" style={{ float: "left" }}></i>
        )}
        {numberFormat(cellContent, 2)}
      </div>
    );
  };

  const CheckStatusManualVolumeData = (cellContent, row) => {
    if (row.FLOWVOLUME == null) {
      cellContent = "";
    } else {
      cellContent = row.FLOWVOLUME;
    }
    let color;
    // if (row.FLOWVOLUMEREF_STATUS < row.FLOWVOLUME_STATUS) {
    if (row.FLOWVOLUMEREF_STATUS == 1) {
      color = "#109600";
    } else if (row.FLOWVOLUMEREF_STATUS == 2) {
      color = "#FCF400";
    }
    // }
    let maxMinIcon;
    if (
      row.FLOWVOLUME != "" &&
      row.FLOWVOLUME != undefined &&
      row.FLOWVOLUME != null
    ) {
      if (
        parseFloat(row.FLOWVOLUME) > parseFloat(row.maximumVolume) ||
        parseFloat(row.FLOWVOLUME) < parseFloat(row.minimumVolume)
      ) {
        if (parseFloat(row.FLOWVOLUME) > parseFloat(row.maximumVolume)) {
          maxMinIcon = "fas fa-arrow-up";
        } else {
          maxMinIcon = "fas fa-arrow-down";
        }
      }
    }

    // console.log(row.maximumVolume)
    return (
      <div className="justify-content-between">
        {" "}
        {row.FLOWSOURCE_NAME == "Manual" && (
          <i
            className="fas fa-edit"
            style={{ float: "left", marginRight: "0.2em" }}
          >
            {" "}
          </i>
        )}{" "}
        {maxMinIcon && (
          <OverlayTrigger
            placement="bottom-end"
            overlay={
              <Tooltip id="tooltip-minmax">
                <p style={{ fontSize: 14 }}>
                  10 Day Min : {numberFormat(row.minimumVolume, 3)}
                </p>
                <p style={{ fontSize: 14 }}>
                  10 Day Max : {numberFormat(row.maximumVolume, 3)}
                </p>
              </Tooltip>
            }
          >
            <i
              className={maxMinIcon}
              style={{ float: "left", color: "rgb(255, 1, 1)" }}
            ></i>
          </OverlayTrigger>
        )}
        {numberFormat(cellContent, 3)}{" "}
        {
          // row.FLOWVOLUMEREF_STATUS < row.FLOWVOLUME_STATUS &&
          row.FLOWSOURCEREF_NAME != null &&
            row.FLOWSOURCEREF_NAME != row.FLOWSOURCE_NAME &&
            row.FLOWVOLUMEREF_STATUS != 3 && (
              <OverlayTrigger
                placement="bottom-end"
                overlay={
                  <Tooltip id="tooltip-disabled">
                    <strong style={{ fontSize: 15 }}>
                      <i
                        className="mdi mdi-circle align-middle mb-2"
                        style={{ color: color }}
                      ></i>{" "}
                      {row.FLOWSOURCEREF_NAME} :{" "}
                      {numberFormat(row.FLOWVOLUMEREF, 3)}
                    </strong>
                  </Tooltip>
                }
              >
                <i
                  className="fas fa-exclamation-circle"
                  style={{ color: color }}
                  onClick={() => {
                    dispatch(
                      confirmAction.showConfirm(
                        "Do you want to change to current data ?",
                        () => {
                          handleSelectDropDownVolumeInput(
                            row.SourceList.find(
                              item => item.label == row.FLOWSOURCEREF_NAME
                            ),
                            row
                          );
                        }
                      )
                    );
                  }}
                ></i>
              </OverlayTrigger>
            )
        }
      </div>
    );
  };

  const CheckStatusManualEnergyData = (cellContent, row) => {
    let color;
    // console.log(row )
    // if (row.ENERGYREF_STATUS < row.ENERGY_STATUS) {
    if (row.ENERGYREF_STATUS == 1) {
      color = "#109600";
    } else if (row.ENERGYREF_STATUS == 2) {
      color = "#FCF400";
    }
    // }
    // console.log(row)
    if (row.ENERGY == null) {
      cellContent = "";
    } else {
      cellContent = row.ENERGY;
    }
    let maxMinIcon;
    if (row.ENERGY != "" && row.ENERGY != undefined && row.ENERGY != null) {
      if (
        parseFloat(row.ENERGY) > parseFloat(row.maximumEnergy) ||
        parseFloat(row.ENERGY) < parseFloat(row.minimumEnergy)
      ) {
        if (parseFloat(row.ENERGY) > parseFloat(row.maximumEnergy)) {
          maxMinIcon = "fas fa-arrow-up";
        } else {
          maxMinIcon = "fas fa-arrow-down";
        }
      }
    }
    return (
      <div className="justify-content-between">
        {" "}
        {row.ENERGYSOURCE_NAME == "Manual" && (
          <i className="fas fa-edit" style={{ float: "left" }}>
            {" "}
          </i>
        )}{" "}
        {maxMinIcon && (
          <OverlayTrigger
            placement="bottom-end"
            overlay={
              <Tooltip id="tooltip-energy-minmax">
                <p style={{ fontSize: 14 }}>
                  10 Day Min : {numberFormat(row.minimumEnergy, 3)}
                </p>
                <p style={{ fontSize: 14 }}>
                  10 Day Max : {numberFormat(row.maximumEnergy, 3)}
                </p>
              </Tooltip>
            }
          >
            <i
              className={maxMinIcon}
              style={{ float: "left", color: "rgb(255, 1, 1)" }}
            ></i>
          </OverlayTrigger>
        )}
        {numberFormat(cellContent, 3)}{" "}
        {
          // row.ENERGYREF_STATUS < row.ENERGY_STATUS &&
          row.ENERGYSOURCEREF_NAME != null &&
            row.ENERGYSOURCE_NAME != row.ENERGYSOURCEREF_NAME &&
            row.ENERGYREF_STATUS != 3 && (
              <OverlayTrigger
                placement="bottom-end"
                overlay={
                  <Tooltip id="tooltip-disabled">
                    <strong style={{ fontSize: 15 }}>
                      <i
                        className="mdi mdi-circle align-middle mb-2"
                        style={{ color: color }}
                      ></i>{" "}
                      {row.ENERGYSOURCEREF_NAME} :{" "}
                      {numberFormat(row.ENERGYREF, 3)}
                    </strong>
                  </Tooltip>
                }
              >
                <i
                  className="fas fa-exclamation-circle"
                  style={{ color: color }}
                  onClick={() => {
                    dispatch(
                      confirmAction.showConfirm(
                        "Do you want to change to current data ?",
                        () => {
                          handleSelectDropDownEnergyInput(
                            row.SourceList.find(
                              item => item.label == row.ENERGYSOURCEREF_NAME
                            ),
                            row
                          );
                        }
                      )
                    );
                  }}
                ></i>
              </OverlayTrigger>
            )
        }
      </div>
    );
  };

  //render Index//
  const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;
  //render Index//

  const CustomerName = (cell, row, rowIndex) => {
    return (
      <>
        {row.PRIORITY_FLAG == 2 ? (
          <OverlayTrigger
            placement="bottom-end"
            overlay={
              <Tooltip id="tooltip-disabled">
                <strong style={{ fontSize: 15, cursor: "pointer" }}>
                  Virtual Meter
                </strong>
              </Tooltip>
            }
          >
            <p className="link-primary" style={{ cursor: "pointer" }}>
              {" "}
              {cell}
            </p>

            {/* <i
          className="fas fa-exclamation-circle"
          style={{ color: '#ffffff' ,float: "right"}}
         
        ></i> */}
          </OverlayTrigger>
        ) : (
          <p> {cell}</p>
        )}
      </>
    );
  };

  const checkCommunication = (cell, row, rowIndex) => {
    // console.log(cell, row)
    return <>{row.PRIORITY_FLAG != 2 && <p>{cell}</p>}</>;
  };

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = "white";

    return style;
  };

  //headerColumn
  const columns = [
    {
      dataField: "Dummy",
      text: "No.",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        backgroundColor: "#7E8EDA",
        width: "2%",
        fontSize: "12px",
      },
      style: {
        width: "2%",
      },
      formatter: CountIndexRow,
    },
    {
      dataField: "METER_NAME",
      text: "Customer",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        backgroundColor: "#7E8EDA",
        width: "9%",
        fontSize: "12px",
      },
      style: {
        width: "9%",
      },
      sort: true,
      formatter: CustomerName,
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          if (column.dataField == "METER_NAME" && row.PRIORITY_FLAG == 2) {
            setVirtualMeter(row);
          }
        },
      },
    },
    {
      dataField: "METER_TYPE",
      text: "Customer Type",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        backgroundColor: "#7E8EDA",
        width: "9%",
        fontSize: "12px",
      },
      style: {
        width: "9%",
      },
      sort: true,
    },
    {
      dataField: "COMTYPE_NAME",
      text: "Communication Type",
      headerAlign: "center",
      editable: false,
      align: "center",
      formatter: checkCommunication,
      headerStyle: {
        backgroundColor: "#7E8EDA",
        width: "9%",
        fontSize: "12px",
      },
      style: {
        width: "9%",
      },
      sort: true,
    },
    {
      dataField: "FLOWVOLUME_STATUS",
      formatter: flowVolumeStatus,
      headerAlign: "center",
      editable: false,
      sort: true,
      align: "center",
      text: "Status",
      headerStyle: {
        backgroundColor: "#6478d7",
        width: "8%",
        fontSize: "12px",
      },
      style: {
        width: "8%",
      },
      // sort: true,
    },
    {
      dataField: "OptionSelected.FLOWSOURCE_NAME",
      formatter: DropDrownVolumeInput,
      text: "Input",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        backgroundColor: "#6478d7",
        width: "10%",
        fontSize: "12px",
      },
      style: {
        width: "10%",
      },
      // sort: true,
    },

    {
      dataField: "FLOWVOLUME",
      formatter: CheckStatusManualVolumeData,
      text: "Data",

      editable: (content, row, rowIndex, columnIndex) =>
        row.FLOWSOURCE_NAME == "Manual",
      headerAlign: "center",
      align: "right",
      headerStyle: {
        backgroundColor: "#6478d7",
        width: "8%",
        fontSize: "12px",
      },
      style: (cell, row, rowIndex, colIndex) => {
        if (row.FLOWSOURCE_NAME == "Manual") {
          return {
            width: "8%",
            cursor: "pointer",
          };
        }
        return {
          width: "8%",
          cursor: "default",
        };
      },
      // style: {
      //   width: "8%",
      // },
      // sort: true,
      validator: (newValue, row, column, done) => {
        if (row.FLOWSOURCE_NAME != "Manual") {
          return true;
        }
        if (isNaN(newValue)) {
          // console.log(newValue);
          // newValue = "";
          return {
            valid: false,
            message: "Should be numeric",
          };
        } else if (newValue < 0) {
          // console.log(newValue);
          return {
            valid: false,
            message: "The value must be greater than 0.",
          };
        }
        return true;
      },
    },
    {
      dataField: "OptionSelected.QTYPOINT_NAME",
      formatter: DropDrownQualityPoint,
      text: "Quality Point",
      editable: false,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        backgroundColor: "#556ee6",
        width: "11%",
        fontSize: "12px",
      },
      style: {
        width: "11%",
      },
      // sort: true,
    },
    {
      dataField: "HEATVALUE",
      formatter: CheckHeatingValue,
      editable: (content, row, rowIndex, columnIndex) =>
        row.QTYPOINT_NAME == "Manual",
      text: "Data",
      headerAlign: "center",
      align: "right",
      headerStyle: {
        backgroundColor: "#556ee6",
        width: "8%",
        fontSize: "12px",
      },
      style: (cell, row, rowIndex, colIndex) => {
        if (row.QTYPOINT_NAME == "Manual") {
          return {
            width: "8%",
            cursor: "pointer",
          };
        }
        return {
          width: "8%",
          cursor: "default",
        };
      },
      // style: {
      //   width: "8%",
      //   cursor: "pointer",
      // },
      // sort: true,
      validator: (newValue, row, column, done) => {
        if (row.QTYPOINT_NAME != "Manual") {
          return true;
        }
        if (isNaN(newValue)) {
          // console.log(newValue);
          // newValue = "";
          return {
            valid: false,
            message: "Should be numeric",
          };
        } else if (newValue < 0) {
          // console.log(newValue);
          return {
            valid: false,
            message: "The value must be greater than 0.",
          };
        }
        return true;
      },
    },
    {
      dataField: "ENERGY_STATUS",
      formatter: energyStatus,
      editable: false,
      sort: true,
      // sortFunc: (a, b, order, dataField) => {
      //   if (order === 'asc') {
      //     return b.value - a.value;
      //   }
      //   return a.value - b.value; // desc
      // },
      text: "Status",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        backgroundColor: "#4362f8",
        // color: "#FFFFFF",
        width: "8%",
        fontSize: "12px",
      },
      style: {
        width: "8%",
      },
    },
    {
      dataField: "OptionSelected.ENERGYSOURCE_NAME",
      formatter: DropDrownEnergyInput,
      text: "Input",
      editable: false,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        backgroundColor: "#4362f8",
        // color: "#FFFFFF",
        width: "10%",
        fontSize: "12px",
      },
      style: {
        width: "10%",
      },
      // sort: true,
    },
    {
      dataField: "ENERGY",
      formatter: CheckStatusManualEnergyData,
      text: "Data",
      editable: (content, row, rowIndex, columnIndex) =>
        row.ENERGYSOURCE_NAME == "Manual",
      headerAlign: "center",
      align: "right",
      headerStyle: {
        backgroundColor: "#4362f8",
        width: "8%",
        fontSize: "12px",
      },
      style: (cell, row, rowIndex, colIndex) => {
        if (row.ENERGYSOURCE_NAME == "Manual") {
          return {
            width: "8%",
            cursor: "pointer",
          };
        }
        return {
          width: "8%",
          cursor: "default",
        };
      },
      // style: {
      //   width: "8%",
      // },
      validator: (newValue, row, column, done) => {
        if (row.ENERGYSOURCE_NAME != "Manual") {
          return true;
        }
        if (isNaN(newValue)) {
          // console.log(newValue);
          // newValue = "";
          return {
            valid: false,
            message: "Should be numeric",
          };
        } else if (newValue < 0) {
          // console.log(newValue);
          return {
            valid: false,
            message: "The value must be greater than 0.",
          };
        }
        return true;
      },
      // sort: true,
    },
  ];

  //headerColumn
  const addHeaderTable = () => {
    // console.log('test')
    let prevHeader = document.getElementById("flow-selection-table-header");
    prevHeader && prevHeader.remove();
    let thead = document
      .getElementById("flow-selection-table")
      ?.getElementsByTagName("thead")[0];
    let tr = document.createElement("tr");
    tr.setAttribute("id", "flow-selection-table-header");
    tr.innerHTML =
      '<th colspan="4" style="border-color: #2A3042;background-color:#2A3042"></th><th colspan="3" style="text-align:center;background-color:#6478d7;color:#FFFFFF;font-size:12px;">Volume ( MMSCF )</th><th colspan="2" style="text-align:center;background-color:#556ee6;color:#FFFFFF;font-size:12px;">Heating Value ( BTU/SCF )</th><th colspan="3" style="text-align:center;background-color:#4362f8;color:#FFFFFF;font-size:12px;">Energy ( MMBTU )</th>';
    thead?.prepend(tr);
  };
  useEffect(() => {
    resetFilter();
    onSearch();
  }, [searchModel]);
  //onInit//
  useEffect(() => {
    if (virtualMeter?.METER_NAME == undefined) addHeaderTable();
  }, [virtualMeter]);
  useEffect(function () {
    mode == "View" ? setReadonly(true) : setReadonly(false);
    // addHeaderTable()
    // getDataConf(pidToSearchConf);
    // resetSearch();
    // resetModel();
    setDropDownStatus(listStatus[0]);
    // setModelDeviceList(listData);

    ///fixed header table
    let tableId = "flow-selection-table";
    let scrollY = 418;
    function fixedTableHeader() {
      let headerTable = document.querySelector(`#${tableId} thead`);
      if (window.scrollY >= scrollY) {
        if (headerTable) headerTable.classList.add("fixed-header");

        resizeTableHeader();
      } else {
        if (headerTable) headerTable.classList.remove("fixed-header");
      }
    }
    function resizeTableHeader() {
      setTimeout(() => {
        let headerTable = document.querySelector(`#${tableId} thead`);
        let tr = document.querySelector(`#${tableId} tbody tr`);
        if (headerTable) {
          let th = headerTable.querySelector(".header-style");
          if (tr) {
            for (var i = 0; i < tr.childNodes.length; i++) {
              th.childNodes[
                i
              ].style.width = `${tr.childNodes[i].offsetWidth}px`;
            }
          }
        }
      }, 1);
    }
    window.addEventListener("scroll", fixedTableHeader);
    document
      .querySelector(`#vertical-menu-btn`)
      .addEventListener("click", resizeTableHeader);
    return () => {
      window.removeEventListener("scroll", fixedTableHeader);
      document
        .querySelector(`#vertical-menu-btn`)
        ?.removeEventListener("click", resizeTableHeader);
    };
    ///fixed header table
  }, []);

  const handleSelectDropDownSearchCustomerType = selected => {
    setDropDownSearchCustomerType(selected);
  };

  const handleSelectDropDownSearchCommunicationType = selected => {
    setDropDownSearchCommunicationType(selected);
  };

  const handleSelectDropDownSearchZone = selected => {
    setDropDownSearchZone(selected);
  };

  const handleSelectDropDownSearchArea = selected => {
    setDropDownSearchArea(selected);
  };

  useEffect(
    function () {
      let COMTYPE_NAME =
        dropDownSearchCommunicationType != null
          ? dropDownSearchCommunicationType.label
          : "";
      let METER_TYPE =
        dropDownSearchCustomerType != null
          ? dropDownSearchCustomerType.label
          : "";
      let AREA_NAME =
        dropDownSearchArea != null ? dropDownSearchArea.label : "";
      let ZONE_NAME =
        dropDownSearchZone != null ? dropDownSearchZone.label : "";

      setFilterTempModel(preVent => ({
        ...preVent,
        COMTYPE_NAME: COMTYPE_NAME,
        METER_TYPE: METER_TYPE,
        AREA_NAME: AREA_NAME,
        ZONE_NAME: ZONE_NAME,
      }));
    },
    [
      dropDownSearchCustomerType,
      dropDownSearchCommunicationType,
      dropDownSearchArea,
      dropDownSearchZone,
    ]
  );
  //onInit//

  // useEffect(
  //   function () {
  //     let LOAD_STATUS = dropDownStatus != null ? dropDownStatus.value : null;
  //     setCreateModel(preVent => ({
  //       ...preVent,
  //       LOAD_STATUS: LOAD_STATUS,
  //     }));
  //   },
  //   [dropDownStatus]
  // );

  //Function CURL

  const resetModel = () => {
    setCreateModel(createObj);
    setDropDownStatus(null);
    // console.log(createModel);
  };

  const onSearch = () => {
    // console.log(searchModel);
    fetchData(searchModel);
  };

  // useEffect(function () {
  //   console.log(filterModel);
  // }, [filterModel]);

  // useEffect(function () {
  //   console.log(filterTempModel);
  // }, [filterTempModel]);

  // useEffect(function () {
  //   console.log(modelDeviceList);
  // }, [modelDeviceList]);

  const onFilter = () => {
    // console.log(filterTempModel);
    setFilterModel({
      COMTYPE_NAME: filterTempModel.COMTYPE_NAME,
      METER_TYPE: filterTempModel.METER_TYPE,
      AREA_NAME: filterTempModel.AREA_NAME,
      ZONE_NAME: filterTempModel.ZONE_NAME,
      METER_NAME: filterTempModel.METER_NAME,
      FLOWVOLUME_STATUS: filterTempModel.FLOWVOLUME_STATUS.map(
        obj => obj.value
      ).toString(),
      ENERGY_STATUS: filterTempModel.ENERGY_STATUS.map(
        obj => obj.value
      ).toString(),
      BLANK_FIELD: filterTempModel.BLANK_FIELD,
    });
    if (filterTempModel.BLANK_FIELD == true) {
      setModelDeviceList(prev => {
        return prev.map(obj => {
          if (obj.FLOWVOLUME && obj.ENERGY && obj.HEATVALUE) {
            obj.isBlank = false;
          } else {
            obj.isBlank = true;
          }
          return obj;
        });
      });
    } else {
    }
  };

  // useEffect(function () {
  //   console.log(filterModel)
  // }, [filterModel]);

  const resetFilter = () => {
    setFilterModel({
      COMTYPE_NAME: "",
      METER_TYPE: "",
      METER_NAME: "",
      AREA_NAME: "",
      ZONE_NAME: "",
      FLOWVOLUME_STATUS: colorOption.map(obj => obj.value).toString(),
      ENERGY_STATUS: colorOption.map(obj => obj.value).toString(),
      BLANK_FIELD: false,
      // FLOWVOLUME_STATUS: {
      //   green: true,
      //   yellow: true,
      //   red: true,
      // },
      // ENERGY_STATUS: {
      //   green: true,
      //   yellow: true,
      //   red: true,
      // },
    });
    setFilterTempModel({
      COMTYPE_NAME: "",
      METER_TYPE: "",
      METER_NAME: "",
      AREA_NAME: "",
      ZONE_NAME: "",
      FLOWVOLUME_STATUS: [...colorOption],
      ENERGY_STATUS: [...colorOption],
      BLANK_FIELD: false,
    });
    setDropDownSearchCommunicationType(null);
    setDropDownSearchZone(null);
    setDropDownSearchArea(null);
    setDropDownSearchCustomerType(null);
    // setFilterEnergyStatus({ red: true, yellow: true, green: true });
    // setFilterFlowVolumeStatus({ red: true, yellow: true, green: true });
  };
  const onClickRevision = () => {
    resetModel();
    setModalRevision(true);
  };

  const onClickRefreshAll = async () => {
    setIsLoading(true);
    try {
      let SELECT_DATE = moment(tempSearch.SELECT_DATE).format("YYYY-MM-DD");
      let res = await post(AUTO_CAL, { SELECT_DATE: SELECT_DATE });
      if (res.resultCode == 200) {
        fetchData({ SELECT_DATE: SELECT_DATE });
        dispatch(messageAction.showMessage("Refresh success."));
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    setIsLoading(false);
  };

  const onClickReCalculate = async () => {
    setIsLoading(true);
    try {
      let SELECT_DATE = moment(tempSearch.SELECT_DATE).format("YYYY-MM-DD");
      let res = await post(AUTO_EX_CAL, { SELECT_DATE: SELECT_DATE });
      if (res.resultCode == 200) {
        fetchData({ SELECT_DATE: SELECT_DATE });
        dispatch(messageAction.showMessage("Recalculate success."));
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    setIsLoading(false);
  };

  const validateForm = () => {
    let bResult = true;
    if (createModel.LOAD_REV == "") {
      bResult = false;
    }

    return bResult;
  };

  const compare = (a, b) => {
    // console.log(a, b);
    if (a.ALIAS_NAME < b.ALIAS_NAME) {
      return -1;
    }
    if (a.ALIAS_NAME > b.ALIAS_NAME) {
      return 1;
    }
    return 0;
  };
  //
  const fetchData = async searchData => {
    setIsLoading(true);
    try {
      let [res, res2, res3, dropdownSearch, maxMin] = await Promise.all([
        post(GET_FLOW_DATA, { ...searchData, METER_TYPE_FLAG: [0, 2] }),
        post(GET_DT_SOURCE_WITH_COM, {}),
        post(GET_QTY_POINT_DATA, { LOAD_DATE: searchData.SELECT_DATE }),
        post(GET_ALL_SELECT, {}),
        post(GET_FLOW_DATA_MAX_MIN_10DAY, {
          SELECT_DATE: searchData.SELECT_DATE,
        }),
      ]);

      // console.log(dropdownSearch);
      setListZone(
        dropdownSearch.data.zoneList
          .sort(compare)
          .map(obj => ({ label: obj.ALIAS_NAME, value: obj.PID }))
      );
      setListArea(
        dropdownSearch.data.areaList
          .sort(compare)
          .map(obj => ({ label: obj.ALIAS_NAME, value: obj.PID }))
      );
      setListCommunicationType(
        dropdownSearch.data.ctCommuList
          .sort(compare)
          .map(obj => ({ label: obj.ALIAS_NAME, value: obj.PID }))
      );
      setListCustomerType(
        dropdownSearch.data.customerTypeList
          .sort(compare)
          .map(obj => ({ label: obj.ALIAS_NAME, value: obj.PID }))
      );

      let allSourceList = res2.data.dtSourceWithComList;
      let allSourceVirtualList = res2.data.dtSourceVirtualWithComList;
      // console.log(allSourceVirtualList);
      // console.log( res.data.flowDataList.filter(row=>row.PRIORITY_FLAG==2),allSourceVirtualList)
      let calculatePid = res2.data.m_SourceCaluratePID;
      let allQtyDataList = res3.data.qtyPointDataList;
      originalModelList = initialModelDataList(
        res.data.flowDataList,
        allSourceList,
        calculatePid,
        allQtyDataList,
        allSourceVirtualList,
        maxMin.data.flowMaxMinDataList
      );

      setModelDeviceList(
        initialModelDataList(
          res.data.flowDataList,
          allSourceList,
          calculatePid,
          allQtyDataList,
          allSourceVirtualList,
          maxMin.data.flowMaxMinDataList
        )
      );
    } catch (err) {
      toggleModalMessage(err.message);
    }
    // setTimeout(() => {
    setIsLoading(false);
    // }, 6000);
  };
  const initialModelDataList = (
    dataList,
    allSourceList,
    calculatePid,
    allQtyDataList,
    allSourceVirtualList,
    maxMinList
  ) => {
    // console.log( allQtyDataList.filter(row => row.QTYPOINT_SOURCE == "SCADA")
    // .sort((a, b) =>
    //   a.QTYPOINT_NAME > b.QTYPOINT_NAME
    //     ? 1
    //     : b.QTYPOINT_NAME > a.QTYPOINT_NAME
    //     ? -1
    //     : 0
    // )
    // .map(row => ({
    //   label: `${row.QTYPOINT_NAME} ${row.QTYPOINT_SOURCE}`,
    //   value: row.QTYPOINT_VALUE,
    //   pid: row.QTYPOINT_PID,
    //   name: row.QTYPOINT_NAME,
    //   source: row.QTYPOINT_SOURCE,
    // })),)
    return dataList.map(obj => {
      let sourceList =
        obj.PRIORITY_FLAG == 0 ? allSourceList : allSourceVirtualList;

      let maximumVolume = maxMinList
        .find(
          max => max.METER_NAME.toLowerCase() == obj.METER_NAME.toLowerCase()
        )
        ?.MAX_FLOWVOLUME?.toFixed(3);
      let minimumVolume = maxMinList
        .find(
          min => min.METER_NAME.toLowerCase() == obj.METER_NAME.toLowerCase()
        )
        ?.MIN_FLOWVOLUME?.toFixed(3);
      let maximumEnergy = maxMinList
        .find(
          max => max.METER_NAME.toLowerCase() == obj.METER_NAME.toLowerCase()
        )
        ?.MAX_FLOWENERGY?.toFixed(3);
      let minimumEnergy = maxMinList
        .find(
          min => min.METER_NAME.toLowerCase() == obj.METER_NAME.toLowerCase()
        )
        ?.MIN_FLOWENERGY?.toFixed(3);
      // console.log(obj.METER_NAME,  obj.FLOWVOLUMEREF_FLAG)
      return {
        ...obj,
        maximumVolume,
        minimumVolume,
        maximumEnergy,
        minimumEnergy,
        FLOWVOLUMEREF_FLAG_CHECK_BOX:
          obj.FLOWVOLUMEREF_FLAG == 2 || obj.FLOWVOLUMEREF_FLAG == 1
            ? true
            : false,
        ENERGYREF_FLAG_CHECK_BOX:
          obj.ENERGYREF_FLAG == 2 || obj.ENERGYREF_FLAG == 1 ? true : false,
        FLOWVOLUME:
          obj.FLOWVOLUME === null || obj.FLOWVOLUME === ""
            ? ""
            : obj.FLOWVOLUME.toFixed(3),
        ENERGY:
          obj.ENERGY === null || obj.ENERGY === "" ? "" : obj.ENERGY.toFixed(3),
        HEATVALUE:
          obj.HEATVALUE === null || obj.HEATVALUE === ""
            ? ""
            : obj.HEATVALUE.toFixed(2),

        OptionSelected: {
          FLOWSOURCE_NAME: {
            label: obj.FLOWSOURCE_NAME,
            value: obj.FLOWSOURCE_PID,
          },
          ENERGYSOURCE_NAME: {
            label: obj.ENERGYSOURCE_NAME,
            value: obj.ENERGYSOURCE_PID,
          },
          QTYPOINT_NAME: {
            label: `${obj.QTYPOINT_NAME} ${
              obj.QTYPOINT_NAME == "Manual" ? "" : obj.QTYPOINT_SOURCE
            }`,
            value: obj.HEATVALUE,
            name: obj.QTYPOINT_NAME,
            source: obj.QTYPOINT_SOURCE,
            pid: obj.QTYPOINT_PID,
          },
        },
        CalculatePid: calculatePid,
        SourceList: sourceList
          .filter(row => row.COM_TYPE == obj.COMTYPE_NAME)
          // .filter(row => row.COM_TYPE == "RTU")
          .map(row => ({ label: row.ALIAS_NAME, value: row.PID })),
        // QtyDataList:allQtyDataList.filter(row=>(row.QTYPOINT_SOURCE=="SCADA")||(row.QTYPOINT_SOURCE=="GQMS"&&row.METER_PID==obj.METER_PID)).map(row=>({label:`${row.QTYPOINT_NAME} ${row.QTYPOINT_SOURCE}` ,value:row.QTYPOINT_VALUE,pid:row.QTYPOINT_PID,source:row.QTYPOINT_SOURCE,name:row.QTYPOINT_NAME}))
        QtyDataList: [
          ...sourceList
            .filter(
              function (row) {
                if (this.count < 1 && row.ALIAS_NAME == "Manual") {
                  this.count++;
                  return true;
                }
                return false;
              },
              { count: 0 }
            )
            .map(row => ({
              label: row.ALIAS_NAME,
              value: "",
              pid: row.PID,
              name: row.ALIAS_NAME,
              source: row.ALIAS_NAME,
            })),
          ...allQtyDataList
            .filter(row => row.QTYPOINT_SOURCE == "SCADA")
            .sort((a, b) =>
              a.QTYPOINT_NAME > b.QTYPOINT_NAME
                ? 1
                : b.QTYPOINT_NAME > a.QTYPOINT_NAME
                ? -1
                : 0
            )
            .map(row => ({
              label: `${row.QTYPOINT_NAME} ${row.QTYPOINT_SOURCE}`,
              value: row.QTYPOINT_VALUE,
              pid: row.QTYPOINT_PID,
              name: row.QTYPOINT_NAME,
              source: row.QTYPOINT_SOURCE,
            })),
          ...allQtyDataList
            .filter(row => row.QTYPOINT_SOURCE != "SCADA")
            .sort((a, b) =>
              a.QTYPOINT_NAME > b.QTYPOINT_NAME
                ? 1
                : b.QTYPOINT_NAME > a.QTYPOINT_NAME
                ? -1
                : 0
            )
            .map(row => ({
              label: `${row.QTYPOINT_NAME} ${row.QTYPOINT_SOURCE}`,
              value: row.QTYPOINT_VALUE,
              pid: row.QTYPOINT_PID,
              name: row.QTYPOINT_NAME,
              source: row.QTYPOINT_SOURCE,
            })),
        ],
      };
    });
  };
  const enegyCalculate = () => {
    setModelDeviceList(prevData => {
      return prevData.map(item => {
        if (item.ENERGYSOURCE_NAME == "Calculate") {
          if (item.FLOWVOLUME != "" && item.HEATVALUE != "") {
            item.SHOW_ENERGY = (item.FLOWVOLUME * item.HEATVALUE).toFixed(3);
            item.ENERGY = (item.FLOWVOLUME * item.HEATVALUE).toFixed(3);
          } else {
            item.SHOW_ENERGY = "";
            item.ENERGY = "";
          }
        }
        return { ...item };
      });
    });
  };
  const volumeCalculate = async data => {
    // let resNom = await post(CHANGE_DATA_ON_SELECT, {
    //   ...data,
    //   SOURCE_NAME: "Nomination",
    // });
    // // resNom.data.objData.ENERGY =10000
    // setModelDeviceList(prevData => {
    //   return prevData.map(item => {
    //     if (
    //       item.FLOWSOURCE_NAME == "Nomination" &&
    //       item.METER_NAME == data.METER_NAME
    //     ) {
    //       if (resNom.data.objData.ENERGY != "" &&  resNom.data.objData.ENERGY != null && item.HEATVALUE != "") {
    //         item.SHOW_FLOWVOLUME = (
    //           resNom.data.objData.ENERGY / item.HEATVALUE
    //         ).toFixed(3);
    //         item.FLOWVOLUME = (
    //           resNom.data.objData.ENERGY / item.HEATVALUE
    //         ).toFixed(3);
    //       } else {
    //         item.SHOW_FLOWVOLUME = "";
    //         item.FLOWVOLUME = "";
    //       }
    //     }
    //     return { ...item };
    //   });
    // });
  };
  const changeDataOnInput = async (data, row, flag) => {
    // console.log(flag)
    setIsLoading(true);
    try {
      let res = await post(CHANGE_DATA_ON_SELECT, data);

      if (res.resultCode == 200) {
        setModelDeviceList(prevData => {
          return prevData.map(item => {
            if (item.PID === row.PID) {
              if (item.ENERGYSOURCE_NAME == "Calculate") {
                item.SHOW_ENERGY = item.FLOWVOLUME * item.HEATVALUE;
                item.ENERGY = item.FLOWVOLUME * item.HEATVALUE;
              }
              if (flag == 1) {
                return {
                  ...item,
                  ...{
                    SHOW_FLOWVOLUME:
                      res.data?.objData?.VOLUME == null
                        ? ""
                        : res.data?.objData?.VOLUME,
                    FLOWVOLUME:
                      res.data?.objData?.VOLUME == null
                        ? ""
                        : res.data?.objData?.VOLUME,
                  },
                  // ...(data.SOURCE_NAME != "Nomination" && {
                  //   SHOW_FLOWVOLUME:
                  //     res.data.objData?.VOLUME == null
                  //       ? ""
                  //       : res.data.objData?.VOLUME,
                  //   FLOWVOLUME:
                  //     res.data.objData?.VOLUME == null
                  //       ? ""
                  //       : res.data.objData?.VOLUME,
                  // }),
                };
              } else if (flag == 2) {
                return {
                  ...item,
                  HEATVALUE:
                    res.data?.objData?.HEATING == null
                      ? null
                      : res.data?.objData?.HEATING,
                };
              } else {
                return {
                  ...item,
                  SHOW_ENERGY:
                    res.data?.objData?.ENERGY == null
                      ? ""
                      : res.data?.objData?.ENERGY,
                  ENERGY:
                    res.data?.objData?.ENERGY == null
                      ? ""
                      : res.data?.objData?.ENERGY,
                };
              }
            }
            return { ...item };
          });
        });
        enegyCalculate();
        // console.log(row);

        if (row.FLOWSOURCE_NAME == "Nomination" || data.SOURCE_NAME) {
          volumeCalculate(data);
        }
      } else {
        toggleModalMessage(res.resultDescription);
      }
    } catch (err) {
      toggleModalMessage(err.message);
    }
    setIsLoading(false);
  };

  const setAllFlagStatusVolumeAndEnergy = () => {
    // setModelDeviceList(modelDeviceList.filter((item) => { item.ENERGY_STATUS == 3 && item.FLOWVOLUME_STATUS == 3 }).map(obj => {
    //   return { ...obj, ENERGYREF_FLAG_CHECK_BOX: true, FLOWVOLUMEREF_FLAG_CHECK_BOX: true }
    // }));
    // fetchData();

    setModelDeviceList(
      modelDeviceList.map(obj => {
        let ENERGYREF_FLAG_CHECK_BOX = false;
        let FLOWVOLUMEREF_FLAG_CHECK_BOX = false;

        if (obj.ENERGY_STATUS == 3) {
          ENERGYREF_FLAG_CHECK_BOX = true;
          // return {
          //   ...obj,
          //   ENERGYREF_FLAG_CHECK_BOX: true,
          //   FLOWVOLUMEREF_FLAG_CHECK_BOX: true,
          // };
        }
        if (obj.FLOWVOLUME_STATUS == 3) {
          FLOWVOLUMEREF_FLAG_CHECK_BOX = true;
        }
        return {
          ...obj,
          ENERGYREF_FLAG_CHECK_BOX,
          FLOWVOLUMEREF_FLAG_CHECK_BOX,
        };
      })
    );

    // setSelectedListUrgent(listAlarmUrgent.filter(item => item.DASHBOARD_FLAG == 1).map(item => item.PID))
  };

  const validateConfirm = productionMode => {
    let bResult = 0;
    // console.log(modelDeviceList);
    if (
      modelDeviceList.length > 0 &&
      (modelDeviceList
        .filter(row => row.ENERGY_STATUS == 3)
        .some(row => row.ENERGYREF_FLAG_CHECK_BOX != true) ||
        modelDeviceList
          .filter(row => row.FLOWVOLUME_STATUS == 3)
          .some(row => row.FLOWVOLUMEREF_FLAG_CHECK_BOX != true))
    ) {
      bResult = 2;
    }

    if (productionMode == true) {
      if (
        modelDeviceList.some(row => {
          return (
            row.ENERGY === null ||
            row.ENERGY === "" ||
            row.FLOWVOLUME === null ||
            row.FLOWVOLUME === ""
          );
        })
      ) {
        bResult = 1;
      }
    }

    return bResult;
    // {permission.eFSN == true && modelDeviceList.length > 0 && modelDeviceList.filter(row => row.ENERGY_STATUS == 3).every(row => row.ENERGYREF_FLAG_CHECK_BOX == true) &&
    //   modelDeviceList
    //     .filter(row => row.FLOWVOLUME_STATUS == 3)
    //     .every(
    //       row =>
    //         row.FLOWVOLUMEREF_FLAG_CHECK_BOX == true
    //     ) &&
    //   modelDeviceList.every(row => {
    //     // if(row.ENERGY==null||row.FLOWVOLUME==null||row.HEATVALUE==null)      console.log(row)

    //     return row.ENERGY != null && row.FLOWVOLUME != null && row.HEATVALUE != null && row.ENERGY != "" && row.FLOWVOLUME != "" && row.HEATVALUE != ""
    //   }
    //   ) && ()}
  };

  const confirmData = async productionMode => {
    // console.log(productionMode);
    // console.log(validateConfirm())
    if (validateConfirm(productionMode) == 0) {
      // console.log("case 1");
      let dataList = modelDeviceList.map(row => {
        let ENERGYREF_FLAG = 1;
        let FLOWVOLUMEREF_FLAG = 1;
        if (row.ENERGYREF_FLAG_CHECK_BOX == true) {
          ENERGYREF_FLAG = 2;
        }
        if (row.FLOWVOLUMEREF_FLAG_CHECK_BOX == true) {
          FLOWVOLUMEREF_FLAG = 2;
        }
        if (row.ENERGY_STATUS != 3) {
          ENERGYREF_FLAG = 2;
        }
        if (row.FLOWVOLUME_STATUS != 3) {
          FLOWVOLUMEREF_FLAG = 2;
        }

        return {
          ...row,
          ENERGYREF_FLAG: ENERGYREF_FLAG,
          GENERATE_REPORT_CHANGE: true,
          FLOWVOLUMEREF_FLAG: FLOWVOLUMEREF_FLAG,
          STATUS_FLAG: 1,
        };
      });
      //1 edit
      //2 check confirm
      // console.log(dataList)
      // console.log(dataList)
      if (
        dataList.every(
          row => row.FLOWVOLUMEREF_FLAG == 2 && row.ENERGYREF_FLAG == 2
        )
      ) {
        setIsLoading(true);
        try {
          let res = await post(SAVE_LIST_FLOW_DATA, dataList);
          if (res.resultCode == 200) {
            dispatch(messageAction.showMessage("Confirm success."));
          } else {
            toggleModalMessage(res.resultDescription);
          }
        } catch (err) {
          toggleModalMessage(err.message);
        }
        setIsLoading(false);
      } else {
        toggleModalMessage("กรุณาตรวจสอบข้อมูล");
      }
    } else if (validateConfirm(productionMode) == 1) {
      // console.log("case 2");
      // console.log(modelDeviceList.filter(row => row.ENERGY == null ||
      //   row.ENERGY == "" ||
      //   row.FLOWVOLUME == null ||
      //   row.FLOWVOLUME == ""
      // ));
      let checkMeterNull = modelDeviceList.filter(
        row =>
          row.ENERGY === null ||
          row.ENERGY === "" ||
          row.FLOWVOLUME === null ||
          row.FLOWVOLUME === ""
      );

      let problemMeter = "";

      for (let i = 0; i < checkMeterNull.length; i++) {
        // problemMeter = problemMeter + ", " + checkMeterNull[i].METER_NAME;
        problemMeter =
          problemMeter == ""
            ? checkMeterNull[i].METER_NAME
            : problemMeter + ", " + checkMeterNull[i].METER_NAME;
      }

      dispatch(
        messageAction.showMessage(
          "กรุณากรอกข้อมูลในช่อง Volume Data และ Energy Data ให้ครบถ้วน รายชื่อ Meter ได้แก่ " +
            problemMeter
        )
      );
    } else if (validateConfirm(productionMode) == 2) {
      // console.log("case 3");
      let checkMeterNull = modelDeviceList.filter(
        row =>
          (row.ENERGY_STATUS == 3 && row.ENERGYREF_FLAG_CHECK_BOX != true) ||
          (row.FLOWVOLUME_STATUS == 3 &&
            row.FLOWVOLUMEREF_FLAG_CHECK_BOX != true)
      );

      let problemMeter = "";

      for (let i = 0; i < checkMeterNull.length; i++) {
        problemMeter =
          problemMeter == ""
            ? checkMeterNull[i].METER_NAME
            : problemMeter + ", " + checkMeterNull[i].METER_NAME;
      }

      dispatch(
        confirmAction.showConfirm(
          "สถานะ สีแดง ของ Volume Status และ Energy Status มีการเช็คไม่ครบถ้วนต้องการ Check All หรือไม่ ? รายชื่อ Meter ได้แก่ " +
            problemMeter,
          () => {
            setAllFlagStatusVolumeAndEnergy();
          }
        )
      );
    }
  };

  const compareOriginalData = (value, other) => {
    // Get the value type
    var type = Object.prototype.toString.call(value);
    // If the two objects are not the same type, return false
    if (type !== Object.prototype.toString.call(other)) return false;

    // If items are not an object or array, return false
    if (["[object Array]", "[object Object]"].indexOf(type) < 0) return false;

    // Compare the length of the length of the two items
    var valueLen =
      type === "[object Array]" ? value.length : Object.keys(value).length;
    var otherLen =
      type === "[object Array]" ? other.length : Object.keys(other).length;
    if (valueLen !== otherLen) return false;

    // Compare two items
    var compare = function (item1, item2) {
      // Get the object type
      var itemType = Object.prototype.toString.call(item1);

      // If an object or array, compare recursively
      if (["[object Array]", "[object Object]"].indexOf(itemType) >= 0) {
        if (!compareOriginalData(item1, item2)) return false;
      }

      // Otherwise, do a simple comparison
      else {
        // If the two items are not the same type, return false
        // console.log(itemType , Object.prototype.toString.call(item2))
        // if (itemType !== Object.prototype.toString.call(item2)) return false;
        // if (item1 != item2) return false;

        // Else if it's a function, convert to a string and compare
        // Otherwise, just compare
        if (itemType === "[object Function]") {
          if (item1.toString() !== item2.toString()) return false;
        } else {
          if (item1 != item2) return false;
        }
      }
    };

    // Compare properties
    if (type === "[object Array]") {
      for (var i = 0; i < valueLen; i++) {
        if (compare(value[i], other[i]) === false) {
          if (
            other[i].FLOWVOLUMEREF_FLAG != 2 &&
            value[i].FLOWSOURCE_NAME != other[i].FLOWSOURCE_NAME
          )
            other[i].FLOWVOLUMEREF_FLAG = 1;
          if (
            other[i].ENERGYREF_FLAG != 2 &&
            value[i].ENERGYSOURCE_NAME != other[i].ENERGYSOURCE_NAME
          )
            other[i].ENERGYREF_FLAG = 1;

          itemChanged.push(other[i]);
        }
      }
    } else {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          if (compare(value[key], other[key]) === false) return false;
        }
      }
    }

    // If nothing failed, return true
    return true;
  };
  const saveData = async () => {
    dispatch(loadingAction.showLoading());
    itemChanged = [];
    compareOriginalData(originalModelList, modelDeviceList);
    let dataEdited = [...itemChanged.map(row => row)];
    if (dataEdited.length == 0) {
      dispatch(messageAction.showMessage("No data changed."));
      dispatch(loadingAction.hideLoading());
      return;
    }
    try {
      let res = await post(SAVE_LIST_FLOW_DATA, dataEdited);
      if (res.resultCode == 200) {
        dispatch(messageAction.showMessage("Save success."));
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (err) {
      dispatch(messageAction.showMessage(err.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const createNewRivision = async () => {
    if (validateForm()) {
      setIsLoading(true);
      try {
        let res = await post(CREATE_NEW_REVISION, { ...createModel, PID: pid });
        // console.log(res);
        if (res.resultCode == 200) {
          dispatch(messageAction.showMessage("Create success."));
          setTimeout(() => {
            backToPageList();
          }, 2000);
          setModalRevision(false);
        } else {
          toggleModalMessage(res.resultDescription);
        }
      } catch (err) {
        toggleModalMessage(err.message);
      }
      setIsLoading(false);
    }
  };

  //Function CURL

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between pb-0">
                    <h1 className="mb-sm-0 font-size-20">
                      {props.t("Flow Selection")} {/* ({mode}) */}
                    </h1>
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link
                            to="/flow-selection"
                            style={{ color: "#556ee6" }}
                          >
                            Flow / HV / Energy Selection
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">
                          Flow Selection
                        </li>
                      </ol>
                    </div>
                  </div>
                </CardBody>
              </Card>
              <Row>
                <Col sm="12">
                  <Card>
                    {virtualMeter?.METER_NAME == undefined && (
                      <CardBody>
                        <Row>
                          <Col sm="12">
                            <Row>
                              <Col sm="12">
                                <FormGroup className="row">
                                  <Col
                                    sm={9}
                                    className=" d-flex align-items-center justify-content-end"
                                  >
                                    <Label> Gas Date: </Label>
                                  </Col>
                                  <Col
                                    sm={3}
                                    className="d-flex align-items-center justify-content-start"
                                  >
                                    <Flatpickr
                                      className="form-control d-block"
                                      placeholder="Select Date"
                                      options={{
                                        altInput: true,
                                        altFormat: "d/m/Y",
                                        // altFormat: "F Y",
                                        dateFormat: "d/m/Y",
                                      }}
                                      onChange={value => {
                                        setSearchModel({
                                          ...searchModel,
                                          SELECT_DATE: moment(value[0]).format(
                                            "YYYY-MM-DD"
                                          ),
                                        });
                                        setTempSearch({
                                          ...tempSearch,
                                          SELECT_DATE: value[0],
                                        });
                                      }}
                                      value={tempSearch.SELECT_DATE}
                                    />{" "}
                                  </Col>
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row className="mt-3">
                              <hr />
                            </Row>
                            <FormGroup className="row mt-2 mb-0">
                              <Col
                                sm={2}
                                className=" d-flex align-items-center justify-content-end"
                              >
                                <Label> Customer: </Label>
                              </Col>
                              <Col
                                sm={3}
                                className=" d-flex align-items-center justify-content-start"
                              >
                                <input
                                  type="text"
                                  className="form-control rounded-2 basicborder"
                                  placeholder={props.t("Search Customer")}
                                  disabled={readonly == true}
                                  onChange={e =>
                                    setFilterTempModel({
                                      ...filterTempModel,
                                      METER_NAME: e.target.value,
                                    })
                                  }
                                  value={filterTempModel.METER_NAME}
                                />
                              </Col>

                              <Col
                                sm={2}
                                className=" d-flex align-items-center justify-content-end"
                              >
                                <Label> Communication Type: </Label>
                              </Col>
                              <Col
                                sm={3}
                                // className=" d-flex align-items-center justify-content-start"
                              >
                                <Select
                                  placeholder="All"
                                  isClearable={true}
                                  value={dropDownSearchCommunicationType}
                                  onChange={
                                    handleSelectDropDownSearchCommunicationType
                                  }
                                  options={listCommunicationType}
                                  classNamePrefix="select2-selection"
                                  styles={SelectStyle}
                                />
                              </Col>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="12">
                            <FormGroup className="row mt-2 mb-0">
                              <Col
                                sm={2}
                                className=" d-flex align-items-center justify-content-end"
                              >
                                <Label> Customer Type: </Label>
                              </Col>
                              <Col sm={3}>
                                <Select
                                  placeholder="All"
                                  isClearable={true}
                                  value={dropDownSearchCustomerType}
                                  onChange={
                                    handleSelectDropDownSearchCustomerType
                                  }
                                  options={listCustomerType}
                                  classNamePrefix="select2-selection"
                                  styles={SelectStyle}
                                />
                              </Col>

                              <Col
                                sm={2}
                                className=" d-flex align-items-center justify-content-end"
                              >
                                <Label> Volume Status: </Label>
                              </Col>
                              <Col
                                sm={3}
                                className=" d-flex align-items-center justify-content-start"
                              >
                                <div style={{ width: "100%" }}>
                                  <Select
                                    classNamePrefix="select2-selection"
                                    isMulti
                                    onChange={selected => {
                                      setFilterTempModel({
                                        ...filterTempModel,
                                        FLOWVOLUME_STATUS: selected,
                                      });
                                    }}
                                    value={filterTempModel.FLOWVOLUME_STATUS}
                                    defaultValue={[...colorOption]}
                                    styles={selectColorOption}
                                    options={colorOption}
                                    components={{
                                      Option: ColorOption,
                                      MultiValueLabel: MultiValueLabelColor,
                                      MultiValueRemovePropsColor,
                                    }}
                                  />
                                </div>
                              </Col>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="12">
                            <FormGroup className="row mt-2 mb-0">
                              <Col
                                sm={2}
                                className=" d-flex align-items-center justify-content-end"
                              >
                                <Label> Zone: </Label>
                              </Col>
                              <Col
                                sm={3}
                                // className=" d-flex align-items-center justify-content-start"
                              >
                                <Select
                                  placeholder="All"
                                  isClearable={true}
                                  value={dropDownSearchZone}
                                  onChange={handleSelectDropDownSearchZone}
                                  options={listZone}
                                  classNamePrefix="select2-selection"
                                  styles={SelectStyle}
                                />
                              </Col>

                              <Col
                                sm={2}
                                className=" d-flex align-items-center justify-content-end pe-3"
                              >
                                <Label> Energy Status: </Label>
                              </Col>
                              <Col
                                sm={3}
                                className=" d-flex align-items-center justify-content-start col-sm-3"
                              >
                                <div style={{ width: "100%" }}>
                                  <Select
                                    classNamePrefix="select2-selection"
                                    isMulti
                                    onChange={selected => {
                                      setFilterTempModel({
                                        ...filterTempModel,
                                        ENERGY_STATUS: selected,
                                      });
                                    }}
                                    value={filterTempModel.ENERGY_STATUS}
                                    defaultValue={[...colorOption]}
                                    styles={selectColorOption}
                                    options={colorOption}
                                    components={{
                                      Option: ColorOption,
                                      MultiValueLabel: MultiValueLabelColor,
                                      MultiValueRemovePropsColor,
                                    }}
                                  />
                                </div>
                              </Col>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="12">
                            <FormGroup className="row mt-2 mb-0">
                              <Col
                                sm={2}
                                className=" d-flex align-items-center justify-content-end"
                              >
                                <Label> Area: </Label>
                              </Col>
                              <Col
                                sm={3}
                                // className=" d-flex align-items-center justify-content-start"
                              >
                                <Select
                                  placeholder="All"
                                  isClearable={true}
                                  value={dropDownSearchArea}
                                  onChange={handleSelectDropDownSearchArea}
                                  options={listArea}
                                  classNamePrefix="select2-selection"
                                  styles={SelectStyle}
                                />
                              </Col>

                              <Col
                                sm={1}
                                className=" d-flex align-items-center justify-content-end"
                              ></Col>
                              <Col
                                sm={5}
                                className=" d-flex align-items-center justify-content-start ms-2"
                              >
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={filterTempModel.BLANK_FIELD}
                                    id="onlyBlank"
                                    onChange={e => {
                                      setFilterTempModel(prev => ({
                                        ...prev,
                                        BLANK_FIELD: e.target.checked,
                                      }));
                                    }}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="onlyBlank"
                                  >
                                    Empty Value Only
                                  </label>
                                </div>
                              </Col>
                            </FormGroup>
                          </Col>
                        </Row>
                        {/* <Row>
                          <Col sm="12">
                            <FormGroup className="row mt-2 mb-0">
                              <Col
                                sm={2}
                                className=" d-flex align-items-center justify-content-end"
                              >
                                <Label> Communication Type: </Label>
                              </Col>
                              <Col
                                sm={3}
                              >
                                <Select
                                  placeholder="All"
                                  isClearable={true}
                                  value={dropDownSearchCommunicationType}
                                  onChange={
                                    handleSelectDropDownSearchCommunicationType}
                                  options={listCommunicationType}
                                  classNamePrefix="select2-selection"
                                  styles={SelectStyle}
                                />
                              </Col>
                              <Col
                                sm={1}
                                className=" d-flex align-items-center justify-content-end"
                              ></Col>
                              <Col
                                sm={5}
                                className=" d-flex align-items-center justify-content-start ms-2"
                              >
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={filterTempModel.BLANK_FIELD}
                                    id="onlyBlank"
                                    onChange={e => {
                                      setFilterTempModel(prev => ({
                                        ...prev,
                                        BLANK_FIELD: e.target.checked,
                                      }));
                                    }}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="onlyBlank"
                                  >
                                    Empty Value Only
                                  </label>
                                </div>
                              </Col>
                            </FormGroup>
                          </Col>
                        </Row> */}
                        <Row className="mt-2">
                          <Col
                            sm={6}
                            className=" d-flex align-items-center justify-content-start"
                          >
                            <div className="d-grid gap-2 d-md-block">
                              {permission.eFSN && (
                                <>
                                  <Button
                                    onClick={() => onClickRefreshAll()}
                                    color="primary"
                                    className="w-md"
                                    disabled={readonly == true}
                                  >
                                    <i className="fas fa-sync-alt"> </i> &nbsp;
                                    Refresh All
                                  </Button>
                                  {/* <Button
                                  onClick={() => onClickReCalculate()}
                                  color="info"
                                  className="w-md ms-3 btn-custom-color"
                                  disabled={readonly == true}
                                >
                                  <i className="mdi mdi-calculator-variant fa-lg"> </i> &nbsp;
                                  Recalculate 
                                </Button> */}
                                </>
                              )}
                            </div>
                          </Col>

                          <Col
                            sm={6}
                            className=" d-flex align-items-center justify-content-end"
                          >
                            <div className="d-grid gap-2 d-md-block">
                              <Button
                                color="info"
                                onClick={() => {
                                  onFilter();
                                }}
                                disabled={readonly == true}
                              >
                                <i className="fas fa-search"> </i> Search
                              </Button>
                              <Button
                                color="warning"
                                className="ms-2"
                                onClick={() => resetFilter()}
                                disabled={readonly == true}
                              >
                                <i className="fas fa-redo-alt"> </i> &nbsp;
                                Reset
                              </Button>
                            </div>
                          </Col>
                        </Row>
                        {/* <Row>
                                    <Col sm="12">
                                      <FormGroup className="row">
                                        <Col
                                          sm={6}
                                          className="d-flex align-items-center justify-content-start"
                                        >
                                          <div>
                                            <Button
                                              onClick={() => onClickRevision()}
                                              color="success"
                                              className="ms-2 w-md"
                                              disabled={readonly == true}
                                            >
                                              <i className="fas fa-plus"></i>
                                              &nbsp; Create New Revision
                                            </Button>
                                          </div>
                                        </Col> */}{" "}
                        {/* <Col
                                          sm={4}
                                          className="d-flex align-items-center justify-content-end"
                                        >
                                          <div>
                                            <Button
                                              onClick={() => onClickRefreshAll()}
                                              color="primary"
                                              className="w-md"
                                              disabled={readonly == true}
                                            >
                                              <i className="fas fa-sync-alt"></i>
                                              &nbsp; Refresh All
                                            </Button>
                                          </div>
                                        </Col> */}{" "}
                        {/* <Col
                                          sm={6}
                                          className="d-flex align-items-center justify-content-end"
                                        >
                                          <h5>
                                            {" "}
                                            Data Date :{" "}
                                            {moment(dataFlowConf.LOAD_DATE).format(
                                              "DD/MM/YYYY"
                                            )}
                                          </h5>
                                        </Col>

                                      </FormGroup>
                                    </Col>
                                  </Row> */}
                        <Row className="mt-3">
                          <hr />
                        </Row>
                        <Row>
                          <Col
                            sm={12}
                            className=" d-flex align-items-center justify-content-start"
                            style={{ fontSize: "1.5vh" }}
                          >
                            <label style={{ color: "#FF0000" }}>*</label>

                            <i
                              className="mdi mdi-circle align-middle mb-2 ms-1"
                              style={{ color: "#109600" }}
                            ></i>

                            <label
                              className="ms-1"
                              style={{ color: "#FFFFFF" }}
                            >
                              สีเขียว : ค่าที่ผ่านมาตรฐาน
                            </label>

                            <i
                              className="mdi mdi-circle align-middle mb-2 ms-2"
                              style={{ color: "#FCF400" }}
                            ></i>

                            <label
                              className="ms-1"
                              style={{ color: "#FFFFFF" }}
                            >
                              สีเหลือง : ค่าที่รอตรวจสอบความถูกต้อง
                            </label>

                            <i
                              className="mdi mdi-circle align-middle mb-2 ms-2"
                              style={{ color: "#FF0000" }}
                            ></i>

                            <label
                              className="ms-1"
                              style={{ color: "#FFFFFF" }}
                            >
                              สีแดง : ค่าที่มีความผิดปกติ
                            </label>

                            <i
                              className="fas fa-arrow-up mb-2 ms-2"
                              style={{ color: "#FF0000" }}
                            ></i>

                            <label
                              className="ms-1"
                              style={{ color: "#FFFFFF" }}
                            >
                              ลูกศรขึ้น : ค่าที่มากกว่าปกติย้อนหลัง 10 วัน
                            </label>

                            <i
                              className="fas fa-arrow-down mb-2 ms-2"
                              style={{ color: "#FF0000" }}
                            ></i>

                            <label
                              className="ms-1"
                              style={{ color: "#FFFFFF" }}
                            >
                              ลูกศรลง : ค่าที่น้อยกว่าปกติย้อนหลัง 10 วัน
                            </label>
                          </Col>
                        </Row>
                        <Row>
                          <TabContent
                            activeTab={activeTab}
                            className="p-3 text-muted pt-0"
                          >
                            <TabPane tabId="1">
                              <Col sm="12">
                                <div>
                                  <BootstrapTable
                                    id="flow-selection-table"
                                    keyField="PID"
                                    data={modelDeviceList.filter(obj => {
                                      // console.log(obj)
                                      let bResultComtypeName = true;

                                      if (filterModel.COMTYPE_NAME != "") {
                                        if (
                                          obj.COMTYPE_NAME?.toLowerCase().includes(
                                            filterModel.COMTYPE_NAME?.toLowerCase()
                                          ) &&
                                          obj.COMTYPE_NAME != null
                                        ) {
                                          bResultComtypeName = true;
                                        } else {
                                          bResultComtypeName = false;
                                        }
                                      }

                                      let bResultZoneName = true;
                                      if (filterModel.ZONE_NAME != "") {
                                        if (
                                          obj.ZONE_NAME?.toLowerCase().includes(
                                            filterModel.ZONE_NAME.toLowerCase()
                                          ) &&
                                          obj.ZONE_NAME != null
                                        ) {
                                          bResultZoneName = true;
                                        } else {
                                          bResultZoneName = false;
                                        }
                                      }

                                      let bResultAreaName = true;
                                      if (filterModel.AREA_NAME != "") {
                                        // alert('เข้าif แรก');
                                        if (
                                          obj.AREA_NAME?.toLowerCase().includes(
                                            filterModel.AREA_NAME.toLowerCase()
                                          ) &&
                                          obj.AREA_NAME != null
                                        ) {
                                          // console.log(obj.AREA_NAME);
                                          bResultAreaName = true;
                                        } else {
                                          bResultAreaName = false;
                                        }
                                      }

                                      let bResultMeterType = true;
                                      if (filterModel.METER_TYPE != "") {
                                        if (
                                          obj.METER_TYPE?.toLowerCase().includes(
                                            filterModel.METER_TYPE.toLowerCase()
                                          ) &&
                                          obj.METER_TYPE != null
                                        ) {
                                          bResultMeterType = true;
                                        } else {
                                          bResultMeterType = false;
                                        }
                                      }

                                      let bResultMeterName = true;
                                      if (filterModel.METER_NAME != "") {
                                        let meterNamaList =
                                          filterModel.METER_NAME.split(",").map(
                                            item => item.toLowerCase()
                                          );

                                        const inFilter =
                                          meterNamaList.findIndex(entry =>
                                            obj.METER_NAME.toLowerCase().includes(
                                              entry
                                            )
                                          );

                                        if (inFilter >= 0) {
                                          bResultMeterName = true;
                                        } else {
                                          bResultMeterName = false;
                                        }
                                      }
                                      let bResultFlowVolume = true;
                                      if (filterModel.FLOWVOLUME_STATUS != "") {
                                        if (
                                          filterModel.FLOWVOLUME_STATUS.toLowerCase().includes(
                                            obj.FLOWVOLUME_STATUS.toString()
                                          )
                                        ) {
                                          bResultFlowVolume = true;
                                        } else {
                                          bResultFlowVolume = false;
                                        }
                                      }

                                      let bResultEnergy = true;
                                      if (filterModel.ENERGY_STATUS != "") {
                                        if (
                                          filterModel.ENERGY_STATUS.toLowerCase().includes(
                                            obj.ENERGY_STATUS.toString()
                                          )
                                        ) {
                                          bResultEnergy = true;
                                        } else {
                                          bResultEnergy = false;
                                        }
                                      }
                                      let bResultBlank = true;
                                      // console.log(obj.isBlank)
                                      if (filterModel.BLANK_FIELD != false) {
                                        bResultBlank = obj.isBlank;
                                      }
                                      // console.log(bResultBlank,obj.FLOWVOLUME,obj.HEATVALUE, obj.ENERGY)
                                      // if (bResultComtypeName &&
                                      //   bResultZoneName &&
                                      //   bResultAreaName &&
                                      //   bResultMeterType &&
                                      //   bResultMeterName &&
                                      //   (bResultFlowVolume || bResultEnergy) &&
                                      //   bResultBlank) {
                                      //   console.log(bResultComtypeName,
                                      //     bResultZoneName,
                                      //     bResultAreaName,
                                      //     bResultMeterType,
                                      //     bResultMeterName,
                                      //     bResultFlowVolume,
                                      //     bResultEnergy,
                                      //     bResultBlank, obj)
                                      // }
                                      return (
                                        bResultComtypeName &&
                                        bResultZoneName &&
                                        bResultAreaName &&
                                        bResultMeterType &&
                                        bResultMeterName &&
                                        (bResultFlowVolume || bResultEnergy) &&
                                        bResultBlank
                                      );
                                    })}
                                    columns={columns}
                                    defaultSorted={defaultSorted}
                                    headerClasses="header-style"
                                    rowStyle={rowStyleFontWhite}
                                    cellEdit={cellEditFactory({
                                      mode: "click",
                                      blurToSave: true,
                                      afterSaveCell: (
                                        oldValue,
                                        newValue,
                                        row,
                                        column
                                      ) => {
                                        enegyCalculate();
                                        if (
                                          row.FLOWSOURCE_NAME == "Nomination"
                                        ) {
                                          let data = {
                                            METER_NAME: row.METER_NAME,
                                            NOMINATE_NAME: row.NOMINATE_NAME,
                                            SOURCE_NAME: "Nomination",
                                            LOAD_DATE: moment(
                                              row.SELECT_DATE
                                            ).format("YYYY-MM-DD"),
                                          };
                                          volumeCalculate(data);
                                        }
                                      },

                                      // nonEditableRows: () => {
                                      //   let listNonEdit = [];
                                      //   modelDeviceList.map((row, index) => {
                                      //     // console.log(row.EnergyInput)
                                      //     if (row.VolumeInput != 'Manual' || row.EnergyInput != 'Manual') {
                                      //       listNonEdit.push(row.Id)
                                      //       console.log(listNonEdit);
                                      //     }
                                      //   })
                                      //   // console.log(listNonEdit)
                                      //   return listNonEdit;
                                      // }
                                    })}
                                  />
                                </div>{" "}
                              </Col>{" "}
                            </TabPane>{" "}
                          </TabContent>{" "}
                        </Row>
                        <Row>
                          {" "}
                          {/* <Col sm="10">
                                      <FormGroup className="row justify-content-end">
                                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                                          Status
                                        </Label>
                                        <Col sm={4}>
                                          <Select
                                            id="STATUS"
                                            // placeholder="( Blank )"
                                            // isClearable={true}
                                            value={dropDownStatus}
                                            onChange={handleSelectDropDownStatus}
                                            options={listStatus}
                                            classNamePrefix="select2-selection"
                                            isDisabled={readonly == true}
                                          />
                                        </Col>
                                      </FormGroup>
                                    </Col> */}{" "}
                          <Col
                            sm="12"
                            className="d-flex align-items-center justify-content-end"
                          >
                            <div className="d-grid gap-2 d-md-block">
                              {permission.eFSN && (
                                <>
                                  <Button
                                    onClick={() => saveData()}
                                    color="success"
                                    className="btn w-md"
                                    disabled={readonly == true}
                                  >
                                    <i className="fab fa-firstdraft"> </i>{" "}
                                    &nbsp; Save Draft
                                  </Button>

                                  <Button
                                    onClick={() => confirmData(true)}
                                    color="info"
                                    className="btn w-md ms-2"
                                    disabled={readonly == true}
                                  >
                                    <i className="bx bx-check-double"> </i>{" "}
                                    &nbsp; Confirm Data
                                  </Button>

                                  {/* <Button
                                    onClick={() => confirmData(false)}
                                    color="primary"
                                    className="btn w-md ms-2"
                                    disabled={readonly == true}
                                  >
                                    <i className="bx bx-check-double"> </i>{" "}
                                    &nbsp; For Testing
                                  </Button> */}
                                </>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    )}
                    <VirtualMeterDetail
                      meter={virtualMeter}
                      selectedDate={moment(tempSearch.SELECT_DATE).format(
                        "YYYY-MM-DD"
                      )}
                      setVirtualMeter={setVirtualMeter}
                    />
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
          <div style={{ marginTop: "200px" }}></div>
        </Container>
      </div>
      {/*start : ModalRefreshAll */}
      <Modal size="lg" isOpen={modalRefreshAll}>
        <div className="modal-header">
          <h5 className="modal-title mt-0"> Refresh </h5>
        </div>
        <div className="modal-body">
          <CardBody>
            <AvForm className="needs-validation">
              <FormGroup className="row mb-3">
                <Label className="col-sm-3 col-form-label text-center">
                  <span style={{ color: "#FF0E03" }}> * </span>
                  Refresh Date Time
                </Label>
                <Col sm={8}>
                  <AvField
                    // readOnly={readonly}
                    name="REFRESH_DATE_TIME"
                    type="text"
                    errorMessage="Enter Refresh Date Time"
                    className="form-control basicborder"
                    validate={{ required: { value: true } }}
                    // style={{ border: "solid 1px #FFFFFF" }}
                    onChange={e =>
                      setCreateModel({
                        ...createModel,
                        REFRESH_DATE_TIME: e.target.value,
                      })
                    }
                    value={createModel.REFRESH_DATE_TIME}
                  />
                </Col>
              </FormGroup>
              <FormGroup className="row mb-3">
                <Label className="col-sm-3 col-form-label text-center">
                  Description
                </Label>
                <Col sm={8}>
                  <Input
                    type="textarea"
                    className="form-control"
                    style={{ borderColor: "#FFFFFF" }}
                    rows="3"
                    // onChange={e =>
                    //   setCreateModel({
                    //     ...createModel,
                    //     DESCRIPTION: e.target.value,
                    //   })
                    // }
                    // value={createModel.DESCRIPTION}
                  />
                </Col>
              </FormGroup>
              <div className="text-center mt-2">
                <button
                  type="submit"
                  className="btn btn-success me-2"
                  // onClick={() => saveRevision()}
                >
                  <i className="bx bx-refresh"> </i> Refresh
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => setModalRefreshAll(false)}
                >
                  <i className="fas fa-times"> </i> Close
                </button>
              </div>
            </AvForm>
          </CardBody>
        </div>
      </Modal>
      {/*end : ModalRefreshAll */}
      {/*start : ModalChangeInput */}
      <Modal size="lg" isOpen={modalChangeInput}>
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            Change Value
          </h5>
        </div>
        <div className="modal-body">
          {/* <Col lg={12}> */} {/* <Card> */}
          <CardBody>
            <Form>
              <Row>
                <FormGroup className="row mb-3">
                  <Label
                    htmlFor="horizontal-firstname-Input"
                    className="col-sm-3 col-form-label text-center"
                  >
                    Data Source
                  </Label>
                  <Col sm={8}>
                    <Select
                      // placeholder="All"
                      // isClearable={true}
                      value={dropDownInput}
                      onChange={handleSelectDropDownInput}
                      options={listVolumeInput}
                      classNamePrefix="select2-selection"
                      styles={SelectStyle}
                    />
                  </Col>
                </FormGroup>
              </Row>
              <Row>
                <FormGroup className="row mb-3">
                  <Label className="col-sm-3 col-form-label text-center">
                    Value
                  </Label>
                  <Col sm={8}>
                    <Input
                      // style={{ border: "solid 1px #FFFFFF" }}
                      type="number"
                      className="form-control basicborder"
                    />
                  </Col>
                </FormGroup>
              </Row>
            </Form>
          </CardBody>
          <div className="text-center">
            <button type="button" className="btn btn-success me-2">
              <i className="fas fa-check"> </i> Select New Value
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setModalChangeInput(false)}
            >
              <i className="fas fa-times"> </i> Close{" "}
            </button>{" "}
          </div>
          <Row className="mt-2">
            <Col sm={6}>
              <span
                className="d-flex align-items-center justify-content-start"
                style={{ color: "#556ee6" }}
              >
                Create By: Mock Data(2021 - 09 - 25 11: 06: 35){" "}
              </span>{" "}
            </Col>{" "}
            <Col sm={6}>
              <span
                className="d-flex align-items-center justify-content-end"
                style={{ color: "#556ee6" }}
              >
                Update By: Test Data(2021 - 09 - 29 09: 19: 39){" "}
              </span>{" "}
            </Col>{" "}
          </Row>{" "}
        </div>{" "}
        {/* -- Model Footer-- */}{" "}
        {/* <div className="modal-footer">
                            <button type="button" className="btn btn-success">Save</button>
                            <button type="button" className="btn btn-light" onClick={() =>
                              this.setState({ modal_backdrop: false })
                            }>Close</button>
                          </div> */}{" "}
        {/* -- Model Footer-- */}{" "}
      </Modal>{" "}
      {/*end : PageAdd */}
      <Loading show={isLoading} />
      <MessageDialog
        isOpen={showMessage}
        hide={toggleModalMessage}
        title={titleMessageModal}
        message={bodyMessageModal}
      />{" "}
    </React.Fragment>
  );
}

FlowSelection.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ FlowSelection }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(FlowSelection));
